module.exports = __webpack_public_path__ + "i18n/pt-BR.dc3cc2c25b303a54091a0b59c982dcf0.json";